import React from 'react';
import {BrowserRouter as Router,Route,Routes} from 'react-router-dom';
import {SnackbarProvider} from 'notistack';
import globalSettingsManagerUtil from '../../utils/global-settings-manager-util';
import ScrollToTop from '../scroll-to-top/scroll-to-top';
import LocalizedRoutes from '../localized-routes/localized-routes';
import styles from './app.module.css';
const App=()=>{
  if(window.location.pathname.length<2){
    window.location.href=`/${globalSettingsManagerUtil.getGlobalSettings().lang}${window.location.hash}`;
    return null;
  }
  return (
    <div className={styles.wrap}>
      <Router>
        <ScrollToTop/>
        <Routes>
          <Route
            path='/:lang/*'
            element={<LocalizedRoutes/>}
          />
        </Routes>
      </Router>
      <SnackbarProvider/>
    </div>
  );
};
export default App;

